import React from 'react';
import { PageHeader } from 'antd';
import logo from '../../Assests/assets/images/layer-1.png';
import './Header.css';

const myHeader = (props) => {
  return (
    <PageHeader
      className="site-page-header"
      backIcon="false"
      title= <img src={logo} class='header-img'/> 
    />
  )
}
export default myHeader;
